
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims",
      function () {
        return require("private-next-pages/rims/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims"])
      });
    }
  